import React from 'react';
import UnderReviewTable from '../business-under-review-report/UnderReviewTable';

export default function BusinessUnderReviewReport() {
    
    return (
        <div>
            <UnderReviewTable />
        </div>
    )
}